import { render } from "./ReportsStreams.vue?vue&type=template&id=06daf16a&scoped=true"
import script from "./ReportsStreams.vue?vue&type=script&lang=js"
export * from "./ReportsStreams.vue?vue&type=script&lang=js"

import "./ReportsStreams.vue?vue&type=style&index=0&id=06daf16a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06daf16a"]])

export default __exports__